
export const HeaderSize = "138px";
export const ToolbarSize = "44px";
export const DefaultPadding = "16px";
